import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetCustomersData from "../../Comman/GetCustomersData";
import GetSoldItesmData from "../../Comman/GetSoldItesmData";
import GetEarnings from "../../Comman/GetEarnings";
import GetItemData from "../../Comman/GetItemData";
import EditInvoiceDataInFirebase from "./EditInvoiceDataInFirebase";
import { AddCustomer, AddItem } from "../..";
import GetSoldItemsData from "../../Comman/GetSoldItesmData";
import GetAssignerUserInvoiceData from "../AssignerUser/Invoices/GetAssignerUserInvoiceDataInFirebase";

const GetInvoiceDataFirebase = async (state, dispatch, sharedBusinesses = null, allCustomers = null) => {
    if (!state?.USERID) return null;

    try {
        const userRef = ref(database, `invoiceGenerator/users/${state?.USERID}/billInvoice`);
        let snapshot = await get(userRef);
        let data = snapshot.val(); // Initialize data here

        let activeInvoices = data
            ? Object.entries(data).filter(([, invoice]) => !invoice?.isDeleted)
            : [];

        let currentItems = [];

        // Ensure customers are fetched even if no personal invoices exist
        const customersToUse = allCustomers || await GetCustomersData(state, dispatch, sharedBusinesses);

        if (activeInvoices.length > 0) {
            GetEarnings(state, dispatch, activeInvoices);
            currentItems = await GetItemData(state, dispatch, activeInvoices);

            const invoicesWithoutCustomer = activeInvoices.filter(([id, invoice]) => !invoice.customerId);

            if (invoicesWithoutCustomer.length > 0) {
                for (const [id, invoice] of invoicesWithoutCustomer) {
                    let matchedCustomer = customersToUse?.find(
                        (cust) => cust?.customer?.toLowerCase()?.trim() === invoice?.customer?.toLowerCase()?.trim()
                    );

                    let customerId;
                    if (!matchedCustomer) {
                        customerId = Date.now().toString();
                        const newCustomer = {
                            companyId: invoice?.companyId || "",
                            customer: invoice?.customer || "Unnamed Customer",
                            customerId,
                            createdAt: Date.now().toString(),
                            updatedAt: Date.now().toString(),
                            phone: invoice?.phone || "",
                            email: invoice?.email || "",
                            address: invoice?.address || "",
                            customerGSTNo: invoice?.customerGSTNo || "",
                            invoiceCount: "1",
                            invoices: [invoice?.invoiceId],
                            totalPaid: "0",
                        };
                        AddCustomer(state, dispatch, newCustomer);
                    } else {
                        customerId = matchedCustomer?.customerId;
                    }

                    const processedItems = (invoice?.items || []).map((item, index) => {
                        const matchedItem = currentItems?.find(
                            (existingItem) => existingItem?.name?.toLowerCase()?.trim() === item?.name?.toLowerCase()?.trim()
                        );
                        return {
                            ...item,
                            itemId: matchedItem?.itemId || `${Date.now()}${index}${invoice?.invoiceId?.toString().slice(0, 4)}`,
                        };
                    });

                    const invoiceData = { ...invoice, invoiceId: id, customerId, items: processedItems };
                    const newItemsToCreate = processedItems.filter(item => !currentItems?.some(existing => existing.itemId === item.itemId));
                    if (newItemsToCreate.length > 0) await AddItem(state, dispatch, newItemsToCreate);
                    await EditInvoiceDataInFirebase(state, dispatch, id, invoiceData);
                }
                snapshot = await get(userRef);
                data = snapshot.val();
                activeInvoices = data
                    ? Object.entries(data).filter(([, invoice]) => !invoice?.isDeleted)
                    : [];
            }
        }

        const formattedData = activeInvoices.map(([uniqueID, info]) => ({
            uniqueID,
            ...info,
            isShared: false
        }));

        const sortedInvoiceData = formattedData
            .sort((a, b) => new Date(parseInt(b.date)) - new Date(parseInt(a.date)))
            .map((item, index) => ({ srNo: index + 1, ...item }));

        let finalInvoices = sortedInvoiceData;

        /* -------- FETCH SHARED INVOICES -------- */

        const businessesToUse = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];

        if (businessesToUse.length) {

            const sharedInvoices = await GetAssignerUserInvoiceData(state, dispatch, businessesToUse);
            finalInvoices = [
                ...sortedInvoiceData,
                ...sharedInvoices
            ];

            console.log("sharedInvoices", sharedInvoices);


        }
        console.log("sortedInvoiceData", sortedInvoiceData);
        /* -------- REMOVE DUPLICATES & SORT AGAIN -------- */

        const invoiceIdMap = new Map();
        finalInvoices.forEach((inv) => {
            // Deduplicate completely using internal invoiceId if available, fallback to uniqueID to prevent table row duplication
            const key = inv.invoiceId ? inv.invoiceId : inv.uniqueID; 
            invoiceIdMap.set(key, inv);
        });

        finalInvoices = Array.from(invoiceIdMap.values())
            .sort((a, b) => new Date(parseInt(b.date)) - new Date(parseInt(a.date)))
            .map((item, index) => ({
                srNo: index + 1,
                ...item
            }));
        dispatch({
            type: actionType.INVOICES,
            payload: finalInvoices
        });

        // GetSoldItemsData(state, dispatch, finalInvoices, currentItems);

        return finalInvoices;

    } catch (error) {
        console.error("Error fetching invoice data:", error);
        return null;
    }
};

export default GetInvoiceDataFirebase;
